// src/components/repository/contactApi.js
import apiService from '../services/apiServices';

export const getContacts = async () => {
  const response = await apiService.get(`/api/contacts/`);
  return response;
};

export async function createContact(payload) {
  const response = await apiService.post(`/api/contacts/`, payload);
  return response.data;
}

export async function updateContact(id, payload) {
  const response = await apiService.patch(`/api/contacts/${id}/`, payload);
  return response.data;
}

export async function deleteContact(id) {
  const response = await apiService.delete(`/api/contacts/${id}/`);
  return response.data;
}

export async function getContactById(id) {
  const response = await apiService.get(`/api/contacts/${id}/`);
  return response;
}
